/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomFieldListOptionCreateBodyParams } from '../models/CustomFieldListOptionCreateBodyParams';
import type { CustomFieldListOptionCreateResponse } from '../models/CustomFieldListOptionCreateResponse';
import type { CustomFieldListOptionDeleteResponse } from '../models/CustomFieldListOptionDeleteResponse';
import type { CustomFieldListOptionGetResponse } from '../models/CustomFieldListOptionGetResponse';
import type { CustomFieldListOptionListResponse } from '../models/CustomFieldListOptionListResponse';
import type { CustomFieldListOptionUpdateBodyParams } from '../models/CustomFieldListOptionUpdateBodyParams';
import type { CustomFieldListOptionUpdateResponse } from '../models/CustomFieldListOptionUpdateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmCustomFieldsDefinitionsOptionsService {
    /**
     * @param definitionId
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns CustomFieldListOptionListResponse Ok
     * @throws ApiError
     */
    public static getCustomFieldListOptions(
        definitionId: number,
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<CustomFieldListOptionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/custom-fields/definitions/{definitionId}/options',
            path: {
                'definitionId': definitionId,
            },
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param definitionId
     * @param requestBody
     * @returns CustomFieldListOptionCreateResponse Ok
     * @throws ApiError
     */
    public static createCustomFieldListOption(
        definitionId: number,
        requestBody: CustomFieldListOptionCreateBodyParams,
    ): CancelablePromise<CustomFieldListOptionCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/custom-fields/definitions/{definitionId}/options',
            path: {
                'definitionId': definitionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param definitionId
     * @param optionId
     * @returns CustomFieldListOptionGetResponse Ok
     * @throws ApiError
     */
    public static getCustomFieldListOption(
        definitionId: number,
        optionId: number,
    ): CancelablePromise<CustomFieldListOptionGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/custom-fields/definitions/{definitionId}/options/{optionId}',
            path: {
                'definitionId': definitionId,
                'optionId': optionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param definitionId
     * @param optionId
     * @param requestBody
     * @returns CustomFieldListOptionUpdateResponse Ok
     * @throws ApiError
     */
    public static updateCustomFieldListOption(
        definitionId: number,
        optionId: number,
        requestBody: CustomFieldListOptionUpdateBodyParams,
    ): CancelablePromise<CustomFieldListOptionUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/crm/custom-fields/definitions/{definitionId}/options/{optionId}',
            path: {
                'definitionId': definitionId,
                'optionId': optionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param definitionId
     * @param optionId
     * @returns CustomFieldListOptionDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteCustomFieldListOption(
        definitionId: number,
        optionId: number,
    ): CancelablePromise<CustomFieldListOptionDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/crm/custom-fields/definitions/{definitionId}/options/{optionId}',
            path: {
                'definitionId': definitionId,
                'optionId': optionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
